import { Component, OnInit, Input,Output, EventEmitter } from '@angular/core';
import { CouponListModel } from 'src/app/models/coupon-list';
import { CommonService } from 'src/app/services/Common-function/common.service';
import { Ga4trackingService } from 'src/app/services/ga4Tracking/ga4tracking.service';
import { BrowserStorageService } from 'src/app/services/browser-storage/browser-storage.service';

@Component({
  selector: 'ipm-coupon-popup',
  templateUrl: './coupon-popup.component.html',
  styleUrls: ['./coupon-popup.component.scss']
})
export class CouponPopupComponent implements OnInit {
  @Input() couponList: Array<CouponListModel> = [];
  @Output() onTriggerApplyEvent: EventEmitter<any> = new EventEmitter();
  couponCode: any = "";
  constructor(private commonService: CommonService,
    public ga4Service: Ga4trackingService,
    public browserService: BrowserStorageService
  ) { }

  ngOnInit(): void {
  }

  closeByDeviceType(closeType: string = "", couponData: any = "") {
    let currentApplyCoupon: any = {};
    if (closeType === "widthData") {
      currentApplyCoupon = {
        code: couponData?.code,
        couponId: couponData?._id
      }
      this.onTriggerApplyEvent.emit(currentApplyCoupon);
    } else {
      this.commonService.closePopUp();
    }
  }

  applyCoupon() {
    let currentApplyCoupon = {
      code: this.couponCode,
      couponId: ""
    }
    let eventNames = "apply_coupon";
    let attributes = {
      label : "cart" ,
      Action : " Click" ,
      userRole : this.browserService?.getCurrentRoles(),
      userId : this.browserService?.getUserId(),
      Category : "Coupon"
    }
    this.ga4Service.sendEvent(eventNames, attributes);
    this.onTriggerApplyEvent.emit(currentApplyCoupon);
  }
}
